__turbopack_context__.v({
  "actions": "NotFound-module__bIURDa__actions",
  "code": "NotFound-module__bIURDa__code",
  "page": "NotFound-module__bIURDa__page",
  "primary": "NotFound-module__bIURDa__primary",
  "secondary": "NotFound-module__bIURDa__secondary",
  "text": "NotFound-module__bIURDa__text",
  "title": "NotFound-module__bIURDa__title",
});
